import type { InconsistencyDetailT } from '../../../common/review-suggestions-side-panel';
import { SUGGESTION_CATEGORY, SUGGESTION_STATE } from '../../../common/review-suggestions-side-panel';
import type { TrackingValidationResultT } from './types';
export const getUniqueTrackingDetailId = (trackingDetail: TrackingValidationResultT) => {
  return `${trackingDetail.annotationId}-${trackingDetail.startFrame}-${trackingDetail.endFrame}`;
};
export const categorizeAnnotationValidationDetails = (annotationValidationDetails: TrackingValidationResultT[] | null): InconsistencyDetailT[] => {
  if (!annotationValidationDetails) {
    return [];
  }
  return annotationValidationDetails.map(annotationValidationDetail => {
    return {
      id: getUniqueTrackingDetailId(annotationValidationDetail),
      startIndex: annotationValidationDetail.startFrame,
      endIndex: annotationValidationDetail.endFrame,
      category: SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY,
      state: SUGGESTION_STATE.PENDING,
      annotationId: annotationValidationDetail.annotationId
    };
  });
};